import { useMutation, useQuery } from '@apollo/client';
import { StandardAlert } from 'component/StandardAlert';
import StandardPopup from 'component/StandardPopup';
import CustomLayout from 'component/layout/custom_layout';
import LoadingDataSpinner from 'component/loading_spinner/loading_data_spinner';
import { WidgetCode } from 'component/popup/constant';
import WidgetPopup from 'component/popup/customize_popup';
import StyleItem from 'component/style_item';
import ZoomImage from 'component/zoom_image';
import UserType from 'constants/user';
import { useAuth } from 'contexts/AuthContext';
import { USER_DETAIL } from 'graph_ql/authentication/queries';
import { GET_ITEM_COMMON } from 'graph_ql/item/queries';
import { UPDATE_STYLE } from 'graph_ql/styles/mutations';
import { GET_STYLE_DETAIL } from 'graph_ql/styles/queries';
import { useQueryData } from 'hooks/useQuery';
import { useUrlQuery } from 'hooks/useUrlQuery';
import { get } from 'lodash';
import _isEmpty from 'lodash/isEmpty';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { use100vh } from 'react-div-100vh';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import { RootState } from 'redux/store';
import { PATH } from 'routes/constant';
import themes from 'styles/themes';
import { TRACK_EVENT, WHATSAPP_REASON_TYPE, trackEvent } from 'utils/analytics';
import { getConsultStylistWAMessage, openWhatsapp } from 'utils/handleSendMessageWhatsapp';
import hanger from '../../assets/svg/no_style_v2.svg';
import styleItemUtils from '../../utils/style_item';
import { ItemStatus } from './constant';
import { setCurrentEditingItemId } from '../../redux/create-style/create-style.slice';
import utils, { getViewStyleNotificationParams, renderTitleWarningEditStyle } from 'utils/utils';
import { CREATE_NOTIFICATION } from 'graph_ql/notification/mutation';
import { setNotifiedStylesId } from 'redux/authentication/user_detail';
import { checkIsPersonalizedStyle, getProductTrackingData } from 'utils/trackUtils';
import config from 'config';
import { STRINGS } from '../../constants';
import { ModelImageProvider } from 'component/vton_card/ModelImageContext';

interface ILocationState {
    from: string;
    messageTaffiId?: string;
    productTaffiId?: string;
}

function StyleDetail() {
    const history = useHistory();
    const dispatch = useDispatch();
    const [title, setTitle] = useState('Style');
    const [showPopupInfo, setShowPopupInfo] = useState(false);
    const taffiId: any = useParams();
    const query = useUrlQuery();
    let itemId = query.get('itemId') as string;
    const itemRoute = useRouteMatch<any>(`${PATH.ITEM_DETAIL}/:taffiId`);
    const isItemOnly = itemRoute?.isExact || false; // need to handle it with url
    const {
        data,
        loading: styleLoading,
        refetch,
    } = useQuery(isItemOnly ? GET_ITEM_COMMON : GET_STYLE_DETAIL, {
        variables: {
            input: {
                taffiId: taffiId?.taffiId,
                paging: {
                    size: 10,
                    page: 0,
                },
            },
        },
        fetchPolicy: 'no-cache',
    });
    const styleData = useMemo(() => get(data, [isItemOnly ? 'getItem' : 'getStyle', 'data', 0]), [data, isItemOnly]);
    const height: any = use100vh();
    const { currentUser } = useAuth();
    const user: any = useQueryData(USER_DETAIL, null, currentUser, false);
    const userDetail = useMemo(() => user?.dataQuery?.me, [user]);
    const [heightContent, setHeightContent] = useState<any>();
    const [showPopup, setShowPopup] = useState(false);
    const [listItem, setListItem] = useState<any>([]);
    const [isShort, setIsShort] = useState(false);
    const [showImage, setShowImage] = useState(false);
    const [itemIndex, setItemIndex] = useState(0);
    const notifiedStylesId = useSelector((state: RootState) => state.userDetail.notifiedStylesId);
    const me = useSelector((state: RootState) => state.userDetail.me);
    const [img, setImg] = useState<any>('');

    const [styleInfo, setStyleInfo] = useState<any>();
    const { state: locationState } = useLocation<ILocationState>();
    const [modalShow, setModalShow] = useState({
        show: false,
        title: '',
        content: '',
        button1: 'Yes',
        onFirstButtonClick: () => {},
        button2: '',
        path: '',
        type: '',
        buttonCancel: 'No',
        closeButton: false,
    });

    const handleViewDetail = (item, itemIndex) => {
        if ((userDetail && userDetail?.userType === UserType.Customer) || !userDetail) {
            setShowPopup(true);
            if (item.length > 1) {
                const items = styleItemUtils.mapItemDataWithPrimaryImages(item);
                setListItem(items);
                setIsShort(false);
            } else {
                setListItem(item.map(styleItemUtils.mapItemData));
                setIsShort(true);
            }
        } else {
            if (
                styleData?.status === ItemStatus.Published ||
                styleData?.status === ItemStatus.PublishToConsumers ||
                styleData?.status === ItemStatus.PublishToUnlisted
            ) {
                setModalShow({
                    ...modalShow,
                    show: true,
                    onFirstButtonClick: () => {
                        handleStyleStatus(ItemStatus.Draft);
                        NavigateToEdit(itemIndex);
                    },
                    title: renderTitleWarningEditStyle(styleData?.status, itemIndex ? 'item' : 'style', styleData),
                });
            } else {
                NavigateToEdit(itemIndex);
            }
        }
    };

    const NavigateToEdit = (itemId) => {
        if (isItemOnly) {
            history.push(`${PATH.EDIT_ITEM}/${styleData?.taffiId}`);
        } else {
            if (itemId) {
                dispatch(setCurrentEditingItemId(itemId));
            }
            history.push(`${PATH.EDIT_STYLE_CANVAS}/${taffiId?.taffiId}`);
        }
    };
    useEffect(() => {
        const heightMain: any = document.getElementById('main')?.offsetHeight;
        if (heightMain) {
            setHeightContent(heightMain);
        }
    }, [height]);
    useEffect(() => {
        if (itemId && !_isEmpty(styleData)) {
            let itemIndex: any = styleData?.items?.findIndex((item: any) => {
                return item?.data?.taffiId === itemId;
            });
            setItemIndex(itemIndex + 1);
        }
    }, [styleData, itemId]);
    const handleClick = (image) => {
        setImg(image);
        setShowImage(true);
    };
    const [createNotificationMutation] = useMutation(CREATE_NOTIFICATION);

    const createNotification = useCallback(
        (input: {
            actionObjectId: String;
            actionObjectType: String;
            actor: String;
            message: String;
            recipient: String;
            targetObjectId: String;
            targetObjectType: String;
            verb: String;
            channels: String[];
            channelInfo: any;
        }) => {
            const variables = {
                input,
            };
            createNotificationMutation({ variables });
        },
        [createNotificationMutation],
    );

    const handleViewStyleNotification = useCallback(
        (activeStyle) => {
            if (activeStyle?.consumersId?.includes(me?.id) && !notifiedStylesId.includes(activeStyle.id)) {
                dispatch(setNotifiedStylesId([...notifiedStylesId, activeStyle.id]));
                const stylist = activeStyle?.user;
                createNotification(getViewStyleNotificationParams({ me, activeStyle, stylist }));
            }
        },
        [createNotification, me, dispatch, notifiedStylesId],
    );
    const trackProductView = useCallback(
        (styleData) => {
            const trackStyleLayoutVersion = true;
            const productViewTrackingData = {
                ...getProductTrackingData(userDetail || me, styleData, styleData, trackStyleLayoutVersion),
                personalized: checkIsPersonalizedStyle(styleData, userDetail || me),
            };
            trackEvent(TRACK_EVENT.PRODUCT_VIEW, productViewTrackingData);
        },
        [me, userDetail],
    );
    useEffect(() => {
        if (!_isEmpty(styleData)) {
            handleViewStyleNotification(styleData);
            trackProductView(styleData);
        }
    }, [styleData, handleViewStyleNotification, trackProductView]);

    const handleWhatsappStyleQuestion = (item, trackEventParams, user, styleTaffiId) => {
        const msg = getConsultStylistWAMessage({
            userDetail,
            item,
            user,
            styleTaffiId,
            isItemOnly,
        });
        openWhatsapp(msg, {
            ...trackEventParams,
            reason: WHATSAPP_REASON_TYPE.STYLIST_CONSULT_REQUEST,
            stylistId: user.id,
            stylistEmail: user?.email,
            stylistName: user?.firstName + ' ' + user?.lastName,
        });
    };

    const handleRedirectToAmira = () => {
        history.push(`${PATH.STYLE_ASSISTANT}`);
    };

    const handleViewInfo = (item) => {
        setShowPopupInfo(true);
        setStyleInfo(item?.collection === 'styles' ? [styleData][0] : item);
        trackEvent(TRACK_EVENT.PRODUCT_INFO_OPEN, getProductTrackingData(userDetail, item?.data, styleData));
    };
    const [updateStyleMutation] = useMutation(UPDATE_STYLE, {
        onCompleted(response) {
            refetch();
        },
        onError: (err) => {
            console.error(err);
        },
    });

    const handleStyleStatus = async (newStatus?: ItemStatus) => {
        const newStatusOnToggleAction =
            styleData.status === ItemStatus.Published ? ItemStatus.Unpublished : ItemStatus.Published;
        const variables = {
            input: {
                id: styleData.id,
                status: newStatus || newStatusOnToggleAction,
            },
        };
        await updateStyleMutation({ variables });
    };
    const handleClickStylist = (style) => {
        history.push(`${PATH.STYLIST_PROFILE}/${style?.user?.userName}`);
    };

    const isShowBackButton = useMemo(
        () => utils.isAppInWidgetMode() && (userDetail?.id || locationState?.from === PATH.STYLE_ASSISTANT),
        [userDetail?.id, locationState?.from],
    );

    return (
        <>
            <CustomLayout
                isLogo={userDetail?.id ? false : true}
                title={userDetail?.id ? title : ''}
                containerStyle={{ background: themes.palette.primary.light }}
                showBackBtn={isShowBackButton}
                showSideBarBtn={!userDetail?.id && !isShowBackButton}
                backTo={
                    (locationState?.from || '').startsWith(PATH.STYLE_ASSISTANT)
                        ? locationState.from && locationState.messageTaffiId && locationState.productTaffiId
                            ? `${locationState.from}?messageTaffiId=${locationState.messageTaffiId}&productTaffiId=${locationState.productTaffiId}`
                            : PATH.STYLE_ASSISTANT
                        : ''
                }
            >
                <ModelImageProvider>
                    <div id="main" style={{ height: '100%', overflowY: 'hidden' }}>
                        {!styleLoading && styleData ? (
                            <StyleItem
                                styleItemData={
                                    isItemOnly
                                        ? { items: [{ data: styleData, id: styleData.id }], ...styleData }
                                        : styleData
                                }
                                isItemOnly={isItemOnly}
                                itemIndex={itemIndex ?? 0}
                                setLoadingReact={() => {}}
                                heightContent={heightContent}
                                handleViewDetail={handleViewDetail}
                                handleClick={handleClick}
                                handleAddtobag={() => {}}
                                handleViewInfo={handleViewInfo}
                                handleSendMessageWA={handleWhatsappStyleQuestion}
                                setTitle={setTitle}
                                handleClickStylist={() => handleClickStylist(styleData)}
                                handleStyleStatus={() =>
                                    setModalShow({
                                        ...modalShow,
                                        show: true,
                                        onFirstButtonClick: handleStyleStatus,
                                        title:
                                            styleData?.status === ItemStatus.Published ||
                                            styleData?.status === ItemStatus.PublishToConsumers ||
                                            styleData?.status === ItemStatus.PublishToUnlisted
                                                ? 'Your style will now be unpublished from Taffi marketplace. Do you want to continue ?'
                                                : 'Your style will now be published to Taffi marketplace. All likes/dislikes and feedbacks associated with this style will be lost. Do you want to continue ?',
                                    })
                                }
                            />
                        ) : (
                            styleLoading === false && (
                                <div style={{ height: '100%', padding: '30px 24px 0' }}>
                                    <StandardAlert
                                        height={`calc( ${heightContent}px - 100px)`}
                                        icon={hanger}
                                        title={STRINGS.STYLE_NOT_FOUND}
                                        body={`${STRINGS.STYLE_NOT_AVAILABLE} ${STRINGS.ASK_AMIRA_FOR_PERSONALIZED_STYLE}`}
                                        onButtonClick={handleRedirectToAmira}
                                        buttonText={STRINGS.ASK_AMIRA_NOW}
                                        isIcon={false}
                                    />
                                </div>
                            )
                        )}
                    </div>
                </ModelImageProvider>
            </CustomLayout>
            {showPopup && (
                <WidgetPopup
                    titlePopup={isShort ? 'Item Details' : 'Style Details'}
                    widgetCode={WidgetCode.ViewDetailStyle}
                    listItem={listItem}
                    setListItem={setListItem}
                    onClose={() => setShowPopup(false)}
                    isButton={utils.isAppInWidgetMode() || config.removeCheckOut ? false : true}
                    isButtonWhite={false}
                    titleButton={isShort ? 'ADD ITEM TO BAG' : 'Add all to bag'}
                    shortPopup={isShort}
                    handleClick={() => {}}
                    loading={false}
                    styleData={styleData}
                />
            )}
            {showPopupInfo && (
                <WidgetPopup
                    titlePopup={styleInfo?.collection === 'styles' ? 'Style Information' : 'Item Information'}
                    widgetCode={WidgetCode.ViewStyleInfo}
                    //infoItem={styleInfo}
                    infoItem={styleItemUtils.getInfo(styleInfo, 'widgetpop')}
                    onClose={() => setShowPopupInfo(false)}
                    pageCode="feed"
                    infoStyle={styleData}
                />
            )}
            {showImage && <ZoomImage img={img} setShowImage={setShowImage} />}
            {styleLoading && <LoadingDataSpinner isBackground={true} />}
            <StandardPopup
                show={modalShow.show}
                onHide={() => setModalShow({ ...modalShow, show: false })}
                title={modalShow.title}
                content={modalShow.content}
                button1={modalShow.button1}
                buttonCancel={modalShow.buttonCancel}
                onSecondButtonClick={() => {
                    if (modalShow.path) {
                        history.push(modalShow.path);
                    }
                }}
                type={modalShow.type as any}
                closeButton={modalShow.closeButton}
                onFirstButtonClick={modalShow.onFirstButtonClick}
            />
        </>
    );
}

export default StyleDetail;
